"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.T_SHIRT_SIZES = void 0;
var T_SHIRT_SIZES = Object.freeze({
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl'
});
exports.T_SHIRT_SIZES = T_SHIRT_SIZES;